import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import { useSelector } from "react-redux";

import CourseOfferingDisplay from "./CourseOfferingDisplay";

const CourseSessionEventModal = ({ onSubmit }) => {
  const {
    catalog: currentCatalog,
    course: currentCourse,
    session: currentSession,
    event: currentEvent,
  } = useSelector((state) => state.courses);

  const courseDetails = {
    title: "Selection details",
    leftCol: [
      { title: "Catalog Id:", info: currentCatalog.catalog_id },
      { title: "Catalog name:", info: currentCatalog.catalog_name },
      { title: "Course Id:", info: currentCourse.course_id },
      {
        title: "Course name:",
        info: `${currentCourse.course_name} (${currentCourse.course_type})`,
      },
      { title: "Session Id:", info: currentSession.session_id },
      { title: "Session Name:", info: currentSession.session_name },
      {
        title: "Session Date:",
        info: `${currentSession.session_date_begin} - ${currentSession.session_date_end}`,
      },
    ],
    rightCol: [
      { title: "Event Id:", info: currentEvent.event_id },
      { title: "Event Name:", info: currentEvent.event_name },
      {
        title: "Event Date:",
        info: `${currentEvent.event_date} - ${currentEvent.event_time}`,
      },
      { title: "Event Venue:", info: currentEvent.event_venue ?? "" },
    ],
  };

  return (
    <Form onSubmit={onSubmit}>
      <CourseOfferingDisplay courseDetails={courseDetails} />
    </Form>
  );
};

export default CourseSessionEventModal;
